import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authQueryApi } from 'features/auth/query';
import { AuthState, TUserInfo } from 'features/auth/types';

const initialState: AuthState = {
  currentUser: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<TUserInfo | null>) => {
      state.currentUser = action.payload;
    },
    clearAuth: () => initialState,
  },
  extraReducers: builder => {
    const { GetCurrentUser } = authQueryApi.endpoints;
    builder.addMatcher(GetCurrentUser.matchFulfilled, (state, action) => {
      state.currentUser = action.payload;
    });
    builder.addMatcher(GetCurrentUser.matchRejected, state => {
      state.currentUser = null;
    });
  },
});

export const { clearAuth, setCurrentUser } = authSlice.actions;
export default authSlice.reducer;
